import React, { useEffect, useState } from "react";

import useDebounce from "hooks/useDebounce";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { T } from "services/lang/LanguageService";

type SearchProps = {
  value: string;
  placeholder?: string;
  onChange: (value: string) => void;
};

const Search: React.FC<SearchProps> = ({ value, placeholder, onChange }) => {
  const [inputValue, setInputValue] = useState(value);
  const debouncedValue = useDebounce(inputValue, { delay: 500 });

  // Update local state when external value changes
  useEffect(() => {
    setInputValue(value);
  }, [value]);

  // Call onChange when debounced value changes
  useEffect(() => {
    if (debouncedValue !== value) {
      onChange(debouncedValue);
    }
  }, [debouncedValue, onChange, value]);

  return (
    <IconField>
      <InputIcon className="pi pi-search ml-2" />
      <InputText
        value={inputValue}
        onChange={e => setInputValue(e.target.value)}
        placeholder={`${placeholder ?? T("action.search")}...`}
        className="px-5"
      />
      <InputIcon
        className="pi pi-times text-sm cursor-pointer"
        onClick={() => {
          setInputValue("");
          onChange("");
        }}
      />
    </IconField>
  );
};

export default Search;
